import Trades from "./tabview/Trade.jsx";
import History from "./tabview/History.jsx";
import { CiCircleList } from "react-icons/ci";
import { BsJournals } from "react-icons/bs";
import { IoMailOutline } from "react-icons/io5";
import { IoIosNotificationsOutline } from "react-icons/io";
import { VscHistory } from "react-icons/vsc";
import { PiTreeViewLight } from "react-icons/pi";
import Alert from "./tabview/alert/Alert.jsx";
import Mail from "./tabview/mail/Mail.jsx";
import News from "./tabview/News.jsx";
import Report from './tabview/reports/Report.jsx';
import AccountTree from "./tabview/AccountTree.jsx";
import { IoNewspaperOutline } from "react-icons/io5";
import NetTrade from "./tabview/netTrade/NetTrade.jsx";
import { PiGraphLight } from "react-icons/pi";
import { BsJournalBookmark } from "react-icons/bs";
import Journals from "./tabview/Journals.jsx";
import { Badge } from "@mui/material";

const data = []
export const getTabList = (unreadCount) => [
  {
    id: 1, name: "trade", icon: <CiCircleList />,
    component: (handleOpenTradeModal, handleOpenModifyPositionModal, handleChartFromTradeTabClick) => <Trades data={data} loading={false} handleOpenTradeModal={handleOpenTradeModal} handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} />,
  },
  { id: 2, name: "netTrade", icon: <PiGraphLight />, component: <NetTrade data={data} />, },
  { id: 3, name: "history", icon: <VscHistory />, component: <History data={data} />, },
  { id: 4, name: "alerts", icon: <IoIosNotificationsOutline style={{ fontSize: 25 }} />, component: <Alert data={data} />, },
  { id: 5, name: "mailBox", icon: (<Badge badgeContent={unreadCount > 999 ? "999+" : unreadCount > 99 ? "99+" : unreadCount > 9 ? "9+" : unreadCount > 0 ? unreadCount : null} color="error" variant={unreadCount > 0 ? "standard" : ""} overlap="circular"><IoMailOutline /></Badge>), component: <Mail />, },
  { id: 6, name: "report", icon: <BsJournals />, component: <Report />, },
  { id: 7, name: "news", icon: <IoNewspaperOutline />, component: <News data={data} />, },
  { id: 8, name: "journals", icon: <BsJournalBookmark />, component: <Journals data={data} />, },
  { id: 9, name: "accounts", icon: <PiTreeViewLight />, component: (setSelectedTab) => <AccountTree setSelectedTab={setSelectedTab} />, },
];

